export default __webpack_public_path__ + "static/media/burned-icon.f7f3210e.svg";